export default {
  message: {
    loading: 'Loading'
  },
  verbs: {
    url_copied: 'URL copied',
    save: 'Save',
    close: 'Close',
    error: 'Error',
    try_again: 'Try again',
    download: 'Download',
    history: 'History',
    apply: 'Apply',
    invalid_parameters: 'Invalid parameters',
    manager: 'Manager',
    loading_error: 'Error while loading data. Try again.',
    edit: 'Make changes?',
    total: 'The number of orders',
    without: 'No courier',
    unsent: 'Unsent',
    statusFilter: 'Filter',
    statusStop: 'Stop'
  },
  auth: {
    login_action: 'Login',
    login: 'Login',
    password: 'Password',
    password_repeat: 'Password repeat',
    account: 'Account',
    profile: 'Profile',
    logout: 'Logout',
    old_password: 'Old password',
    key: 'Enter a code'
  },
  filter: {
    webmaster_grid: 'Webmaster (on grids)',
    webmaster: 'Webmaster'
  },
  statistic: {
    ad_approved: 'Advertising',
    ad_pre_approved: 'Pre-approval advertising',
    ad_difference: 'Difference of advertisements',
    ad_approve_percent: '% approval',
    averageBuyback: 'Average Buyback',
    revenue_lead: 'Revenue Lead',
    total_revenue: 'Total revenue',
    deviation_mean: 'Deviation Mean',
    day: 'Day',
    traffic: 'Traffic',
    last_update: 'Last update',
    last_version: 'Current version',
    averageBill: 'Average bill',
    averageBillLocal: 'Average bill (local)',
    average_x_price: 'Average x start price',
    approve: 'Approve',
    approve_percent: 'Approve total',
    approved: 'Approved',
    approvedFromValid: 'Approved from valid',
    leads: 'Leads',
    quantity: 'Quantity',
    offers: 'Offers',
    offer: 'Offer',
    filters: 'Filters',
    adult: 'Adult',
    slimming: 'Slimming',
    beauty: 'Beauty',
    health: 'Health',
    economizers: 'Economizers',
    lowPrice: 'Low Price',
    hair: 'Hair',
    sport: 'Sport',
    other: 'Other',
    date: 'Date',
    total: 'Total',
    processed: 'Processed',
    accepted: 'Accepted',
    canceled: 'Canceled',
    canceled_by_reason: 'Сanceled by reason',
    canceledPercents: 'Canceled %',
    error: 'Error',
    errorPercents: 'Error %',
    return: 'Return',
    returnPercents: 'Return %',
    paid: 'Paid',
    paidPercents: 'Paid %',
    in_total: 'In total',
    webmaster: 'Webmaster',
    proportion: 'Proportion',
    buyoutSum: 'Buyout sum',
    acceptedSum: 'Accepted sum',
    operator: 'Operator',
    processed_leads: 'Processed leads',
    points: 'Points',
    operators: 'Operators',
    actions: 'Actions',
    courier: 'Courier',
    shipped: 'Shipped',
    couriers: 'Couriers',
    transit: 'Transit',
    delivered: 'Delivered',
    buyout: 'Buyout',
    additional_sale: 'Add. sale',
    old_bonus: 'Bonus',
    new_bonus: 'New bonus',
    bonus_system: 'Bonus system',
    exporting_history: 'Exporting history',
    paid_bonus: 'Paid bonus',
    system_bonus: 'System bonus',
    reason: 'Reason',
    month: 'Month',
    week: 'Week',
    debt: 'Advertise debit',
    country: 'Country',
    to_pay_for_today: 'To pay for today',
    payout_for_the_week: 'Payout for the week',
    last_payout: 'Last payout',
    cancel_title: 'Reason for cancel',
    cancel_count: 'Cancellations',
    return_title: 'Reason for return',
    return_count: 'Returns',
    refundsId: 'ID',
    AcceptCancel: 'Accept Cancel',
    CancelAccept: 'Cancel Accept',
    ProcessAccept: 'Process Accept',
    ProcessCancel: 'Process Cancel',
    ProcessSpam: 'Process Spam',
    SpamAccept: 'Spam Accept',
    spam: 'Spam',
    average_payment: 'Average payment for the period',
    last_payment: 'Actual payment',
    payment_fix: 'Settlement payment',
    fix_to: 'Became',
    fix_from: 'It was',
    payment_history: 'History of changes',
    vat: 'VAT',
    out: 'OUT',
    profitlid: 'PROFIT from 1 lead',
    profitperiod: 'PROFIT for the period',
    packaging: 'Packaging',
    shippeds: 'Ship',
    average_payments: 'Average Payments',
    user: 'User',
    product: 'Product',
    products: 'Products',
    balance: 'Balance',
    unloaded_leads: 'Unloaded leads',
    unloaded_product: 'Unloaded product',
    delays_leads: 'Delays leads',
    delays_product: 'Delays product',
    stock_product: 'Stock product',
    order_product: 'Order product',
    comment: 'Comment',
    price: 'Price',
    project: 'Project',
    price_for_one: 'Unit price',
    balance_on_the_first_day_of_the_month: 'Balance on the first day of the month',
    total_money: 'Total',
    provider: 'Provider',
    logistic: 'Logistics',
    customs: 'Customs',
    time: 'Time',
    times: 'Date',
    status: 'Status',
    ordered: 'Ordered',
    credit: 'Credit',
    shift: 'Changes',
    by_graph: 'By graph',
    time_success_call: 'Average time to a successful call',
    time_recall: 'Average time to chime',
    expenses_by_lead: 'Expenses by lead',
    expected_lead_increase: 'Expected lead increase',
    cost_change: 'Cost change',
    sets: 'Sets',
    city: 'City',
    cost_price: 'Cost price',
    dialer: '% Dialer',
    average_first_call_time: 'Average First Call Time',
    average_number_touches: 'Average Number Touches',
    average_calls: 'Average Number Calls',
    active_operators: 'Active operators',
    ringing_holds: 'Holds ringing',
    cross_sell: 'Cross sell',
    worked: 'Worked',
    one_day_dialer: 'One day dialer',
    sending_check: 'Sending check',
    foreclosure_check: 'Foreclosure Check',
    call_duration: 'Call Duration',
    time_processing: 'Time Processing',
    time_out_calls: 'Time out of calls',
    call_duration_approve: 'Call duration approve',
    call_duration_cancel: 'Call duration cancel',
    total_cancel: 'Total cancellations',
    processed_all: 'Processed all',
    another: 'Other',
    expensive: 'Expensive',
    not_order: 'Not order',
    changed_mind: 'Changed mind',
    bad_reputation: 'Bad reputation',
    consultation: 'Consultation',
    not_allowed: 'Not allowed',
    medical_contraindications: 'Medical contraindications',
    not_ringing_long_time: 'Not ringing long time',
    not_make_contact: 'Not make contact',
    no_coverage: 'No coverage',
    blacklisted_customer: 'Blacklisted customer',
    not_delivery_time: 'Not delivery time',
    already_bought: 'Already bought',
    suite_different_price: 'Suite different price',
    any_reasons: 'Any reasons',
    template_sms: 'SMS template',
    parts_sms: 'Number of SMS parts',
    sent_sms: 'Sent SMS',
    total_amount: 'Total amount',
    approvals: 'Approvals',
    cross_sell_cost: 'Cross sell cost',
    orders_accepted: 'Orders accepted',
    no_payment_method: 'Not satisfied with the payment method (card / cash)',
    form_release: "I don't like the form of release of the product",
    want_guarantees: 'Guarantees and refunds',
    not_processed: 'Orders cannot be processed at this time',
    expensive_delivery: 'Expensive delivery',
    no_pay_tax: "Doesn't want to pay tax",
    no_nearby: 'There is no client nearby',
    other_information: 'The site has other information about the product',
    won_gift: 'The client thought he had won a gift',
    language_barrier: 'Language barrier',
    wrong_data: 'Wrong number, wrong place',
    drop_calls: 'The client drops the call / cannot be confirmed',
    silent: 'Clients are silent and do not talk',
    under_18: 'Client under 18 years of age'
  },
  filters: {
    clean: 'Clean',
    select_all: 'Select all',
    reset: 'Reset',
    more_pre: 'and ',
    more_post: ' more',
    apply: 'Apply',
    reset_all: 'Reset all',
    yesterday: 'Yesterday',
    week: 'Week',
    this_month: 'This month',
    last_month: 'Last month',
    copy_filter: 'Copy filter',
    filter_copied: 'Filter copied',
    filter_copied_error: 'Copy error',
    period: 'Period',
    by_wm: 'By web1',
    by_manual: 'By manual'
  },
  country: {
    '1528': 'Vietnam',
    '1534': 'Egypt',
    '1522': 'India',
    '1536': 'Iran',
    '1529': 'Indonesia',
    '1527': 'Morocco',
    '1525': 'Malaysia',
    '1537': 'Nigeria',
    '1531': 'Pakistan',
    '1535': 'Russia 2',
    '77': 'Russia',
    '1532': 'Thailand 4',
    '1526': 'Turkey 2',
    '1530': 'Thailand 3',
    '1533': 'Philippines 2',
    '1524': 'Philippines',
    '1538': 'Tunis',
    '1539': 'Indonesia 2',
    '1540': 'Europe',
    '1541': 'Test',
    '1542': 'Colombia',
    '1543': 'Algeria',
    '1544': 'Myanmar',
    '1545': 'UAE',
    '1546': 'Singapore',
    '1547': 'Russia 3',
    '1548': 'GreenGo',
    '1549': 'India 2',
    '1550': 'Peru',
    '1551': 'PRO India',
    '1552': 'PRO Indonesia',
    '1553': 'PRO Malaysia',
    '1554': 'PRO Philippines',
    '1555': 'PRO Vietnam',
    '1556': 'PRO Tunis',
    '1557': 'PRO Colombia',
    '1558': 'PRO Russia',
    '1559': 'PRO Ukraine',
    '1560': 'PRO Kazakhstan',
    '1561': 'PRO Nigeria',
    '1562': 'Test',
    '1563': 'PRO Thailand',
    '1564': 'PRO Iraq',
    '1565': 'PRO South Africa',
    '1566': 'PRO Venezuela',
    '1567': 'PRO Argentine',
    '1568': 'PRO Chile',
    '1569': 'PRO Uruguay',
    '1570': 'PRO Ecuador',
    '1571': 'PRO Peru',
    '1573': 'PRO Morocco',
    '1574': 'PRO Mexico',
    '1576': 'PRO Bangladesh',
    '1580': 'PRO Sri Lanka',
    '1581': 'PRO Laos',
    '1582': 'PRO Europe',
    '1583': 'PRO Uzbekistan',
    '1584': 'PRO Nepal',
    '1585': 'PRO Kenya',
    '1588': 'Test 2',
    '1589': 'Myanmar 2',
    '1572': 'PRO Myanmar',
    '1591': 'PRO Myanmar 2',
    '1592': 'PRO Indonesia 2',
    '1593': 'PRO India 2',
    '1594': 'Colombia 2',
    '1595': 'PRO Mexico 2',
    '1596': 'PRO Colombia 2',
    '1597': 'GGTeam',
    '1598': 'PRO Kazakhstan 2',
    '1599': 'PRO Guatemala',
    '1600': 'PRO Singapore',
    '1601': 'Chile',
    '1602': 'Pakistan',
    '1603': 'Ethiopia',
    '1604': 'Ecuador',
    '1605': 'USA',
    '1606': 'Iran 1',
    '1608': 'For tests',
    '1609': 'PRO Algeria',
    '1610': 'Sri-Lanka',
    '1611': 'PRO Costa-Rica',
    '1612': 'PRO Dominican Republic',
    '1613': 'PRO Egypt 2',
    '1614': 'PRO Honduras',
    '1615': 'PRO Ivory Coast',
    '1616': 'PRO Jordan',
    '1617': 'PRO Nigeria 2',
    '1618': 'PRO South Africa 2',
    '1619': 'PRO Bolivia',
    '1620': 'PRO Kenya 2',
    '-1': 'All'
  },
  return_reason: {
    1: 'VERY_EXPENSIVE',
    2: 'CHANGED_ONES_MIND',
    3: 'DELIVERY_TOOK_TO_LONG',
    4: 'BAD_QUALITY_OF_PACKAGE',
    5: 'COURIER_INCREASED_AMOUNT',
    6: 'NO_NOTIFICATION_FROM_COURIER',
    7: 'RUDE_COURIER',
    8: 'NO_DELIVERED_AFTER_FIRST_ATTEMPT',
    9: 'CUSTOMER_OUTSIDE_OF_CITY',
    10: 'DELIVERED_BOY_DID_NOT_CAME',
    11: 'PIN_CODE_MISTAKE',
    12: 'CUSTOMER_IS_NOT_AVAILABLE',
    13: 'BOUGHT_ANOTHER_PRODUCT',
    14: 'MONEY_PROBLEM',
    15: 'CAN_NOT_OPEN_PARCEL',
    16: 'CAN_NOT_PAY_VIA_CREDIT_CARD'
  },
  pages: {
    web_analysis: 'Web analysis',
    statistic: 'Statistic',
    refunds: 'Returns',
    ref_cancel: 'Statistics on cancellations',
    ref_return: 'Statistics on returns',
    ref_cancel_by_month: 'Statistics on cancellations by month',
    ref_return_by_month: 'Statistics on returns by month',
    ref_cancel_operators: 'Operator cancellation statistics',
    webmasters: 'Webmasters',
    dashboard: 'Main',
    analytics: 'Analytics',
    conversions: 'Statistic',
    by_country: 'Country',
    by_offers: 'Offers',
    by_category_product: 'Category Product',
    by_balance_currency: 'Balance Currency',
    by_period: 'Period',
    operators: 'Operators',
    efficiency: 'Efficiency',
    activity: 'Activity',
    buyout: 'Buyout',
    return_reason: 'Return reason',
    by_couriers: 'By couriers',
    by_weeks: 'By weeks',
    by_days: 'By days',
    by_month: 'By month',
    by_graph: 'By graph',
    by_pieces: 'By pieces',
    changelog: 'Change Log',
    changeversion: 'Versions',
    order: 'Processing orders',
    conversion: 'Сonversion',
    new_orders: 'New Orders',
    new_orders_week: 'By weeks',
    operator_conversions: 'Conversion statistics for operators',
    individual_rates: 'Individual rates',
    webmaster_statistic: 'Statistics for webmasters',
    webmaster_individual_rates: 'Statistics on individual rewards of webmasters',
    orders: 'Orders',
    receipt: 'Receipt',
    remnants: 'Remnants',
    product: 'Product',
    offer: 'Offer',
    offer_rent: 'Profitability offers',
    rentability: 'Rentability',
    expenses_by_kc: 'Expenses by KC',
    timing_kc: 'Work timing KC',
    call_statistics: 'Call Statistics',
    operators_analysis: 'Operators',
    source_statistic: 'Statistics for source',
    sources: 'Sources',
    landing: 'Landing',
    landing_statistic: 'Statistics for landing',
    arrival_new_leads: 'Arrival of new leads',
    grid_statistic: 'Statistics for grid',
    approved_during_the_day: 'Approved during the day',
    orders_receipt: 'Orders/Receipt',
    buyouts_flypost: 'Buyouts Flypost',
    sent_sms_template: 'Sent sms template',
    webmasters_notify: 'Webmasters successfully copied'
  },
  profile: {
    gravatar_change_avatar: 'You may change your avatar at ',
    avatar: 'Avatar',
    security: 'Security',
    change_password: 'Change password',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    personal_information: 'Personal Information',
    password_error_9: 'Password length must be 6 or more symbols',
    password_error_8: 'Passwords did not match',
    password_error_10: 'Old password is invalid',
    password_changed: 'Password changed',
    need_all: 'Please fill all fields',
    updated: 'Profile updated',
    language: 'Language',
    language_changed: 'Language changed',
    for_developer: 'For developers',
    developer_mode: 'Developer mode'
  },
  month: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js